import React, {Component} from 'react';
import {authService} from "../../../auth";
import mappingUtils from "../../../project/component/commons/utils/mappingUtils";
import axios from "axios";
import UnAuthEducationPopUp from "./UnAuthEducationPopUp";



class UnAuthEducation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            educationsList: []

        }
    }

    componentDidMount() {
        this.getEducations();

    }

    getEducations = () => {
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/unauth/get/education?id=' + this.props.userId,
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.status === '200 OK') {
                this.setState({'educationsList': res.body.list})
            }

        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    error: {message: err.response.data.message, err: err.response}
                })
            }
        });
    };
    render() {
        return (
            <div className="profcolwidget">
                <div className="titlewrp">
                    <h2>Education</h2>
                    {this.state.educationsList &&
                    this.state.educationsList.length>4 &&
                    <a href="#educationViewpop" data-toggle="modal">View all</a>
                    }
                </div>
                <div className="profcolwidgetdesc">
                    {this.state.educationsList &&  this.state.educationsList.length===0 &&
                    <div className="zdata">
                        <div className="imgbox"><img src="https://cdn.dscovr.com/images/zero-profile-left5.webp"
                                                     onError={(e) => {
                                                         e.target.onerror = null;
                                                         e.target.src = "https://cdn.dscovr.com/images/zero-profile-left5.png"
                                                     }} alt=""/></div>
                        <div className="desc">
                            <h4>No Education Updated!</h4>
                        </div>
                    </div>}
                    <div className="profeducat">
                        <ul>
                            {this.state.educationsList && this.state.educationsList.map((data, index) =>{
                                if(index<5) {
                                    return <li key={index}>
                                        <figure className="complogo"><img
                                            src="https://cdn.dscovr.com/images/educ1.webp" onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/educ1.png"}} alt=""/></figure>
                                        <div>
                                            <h5>{data.institution}</h5>
                                            <p>{data.specialisations}</p>
                                            <span>{new Date(data.startTime).toLocaleDateString('en-GB', {
                                                day: '2-digit', month: 'short', year: 'numeric'
                                            }).replace(/ /g, '-')} to {mappingUtils.getEndDateCustomForExperience(data.endTime)}</span>
                                        </div>
                                    </li>
                                }
                            })}

                        </ul>
                    </div>
                </div>
                <UnAuthEducationPopUp educationsList={this.state.educationsList}/>
            </div>
        );
    }
}



export default UnAuthEducation;
